import { LimitationLiabilityModal } from './LimitationLiabilityModal.jsx';

export default LimitationLiabilityModal;
